import React from 'react';
import { Card, CardText, CardBody, CardLink, CardTitle, CardSubtitle } from 'seduo-ui';
const Example = (props) => (<div>
        <Card>
            <CardBody>
                <CardTitle>Card title</CardTitle>
                <CardSubtitle>Card subtitle</CardSubtitle>
            </CardBody>
            <img width="100%" src="https://dummyimage.com/318x180/9fa4a8/fff.png" alt="Card image cap"/>
            <CardBody>
                <CardText>
                    Some quick example text to build on the card title and make up the bulk of the card's content.
                </CardText>
                <CardLink href="#">Card Link</CardLink>
                <CardLink href="#">Another Link</CardLink>
            </CardBody>
        </Card>
    </div>);
export default Example;
